import useFetch from '@hooks/useFetch';
import { processNextTrack } from '@api/hooks/course/utils';
import { emptyObject } from '@constants/empty';

const nextCourseTrackMiddleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config);
  const processedNextTrackData = swr.data?.processed
    ? swr.data
    : processNextTrack(swr.data || emptyObject);

  return {
    ...swr,
    data: processedNextTrackData
  };
};

export const getKey = (courseUID) => `v1/collection/${courseUID}/next_track/`;

const useCourseTrack = (
  courseUID,
  options = {
    revalidateOnMount: false,
    selector: null,
    fallbackData: undefined
  }
) => {
  const key = getKey(courseUID);

  const {
    data: courseTrack,
    isValidating,
    ...rest
  } = useFetch(
    key,
    {},
    {
      use: [nextCourseTrackMiddleware],
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  if (options.selector && typeof options.selector === 'function') {
    return options.selector(courseTrack || emptyObject);
  }

  return {
    key,
    courseTrack: courseTrack || emptyObject,
    isValidating,
    ...rest
  };
};

export default useCourseTrack;
